import React from "react";
import { Row } from "react-bootstrap";

function HiddenWrapperRow(props) {
  /* HACK: 0px to keep the row small when the 'Child' is visible */
  return (
    <Row className="offset-md-8" style={{ height: "0px" }}>
      {props.children}
    </Row>
  );
}

export default HiddenWrapperRow;
